
    import {
        defineComponent, type PropType, ref,
    } from 'vue';

    export default defineComponent({
        name: 'Tooltip',
        props: {
            typeTooltip: {
                type: String as PropType<'white' | 'black'>,
                default: 'white',
            },
            contentPosition: {
                type: String as PropType<'top' | 'right' | 'bottom' | 'left'>,
                default: 'top',
            },
            width: {
                type: Number,
                default: 234,
            },
            hideDelay: {
                type: Number,
                default: 0,
            },
        },
        setup(props) {
            const isVisible = ref(false);
            let hideTimeout: ReturnType<typeof setTimeout> | null = null;

            const showTooltip = () => {
                if (hideTimeout) {
                    clearTimeout(hideTimeout);
                    hideTimeout = null;
                }
                isVisible.value = true;
            };

            const hideTooltip = () => {
                if (props.hideDelay > 0) {
                    hideTimeout = setTimeout(() => {
                        isVisible.value = false;
                    }, props.hideDelay);
                } else {
                    isVisible.value = false;
                }
            };

            return {
                isVisible,
                showTooltip,
                hideTooltip,
            };
        },
    });
